import { render, staticRenderFns } from "./new-message-nurse.vue?vue&type=template&id=3aa2b74c&scoped=true"
import script from "./new-message-nurse.vue?vue&type=script&lang=js"
export * from "./new-message-nurse.vue?vue&type=script&lang=js"
import style0 from "./new-message-nurse.vue?vue&type=style&index=0&id=3aa2b74c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa2b74c",
  null
  
)

export default component.exports